import dayjs, { Dayjs } from "dayjs";
import { IObject } from "../App";

export function range(start: number, end: number) {
    const result = [];
    for (let i = start; i < end; i++) {
        result.push(i);
    }
    return result;
}

export function disabledHoursForDate(date: Date | undefined, object: IObject, disableMinutesFromEnd?: number, offsetStart?: number, offsetEnd?: number, startTime?: Dayjs): number[] {
    let currentTime = new Date();

    let selectedDate = date;
    if (!selectedDate) {
        return range(0, 24);
    }

    let selectedDateWorktime = object.worktime.find(worktimeForDay => {
        return worktimeForDay.dayOfWeek === selectedDate?.getDay();
    });

    if (!selectedDateWorktime) {
        return range(0, 24);
    }

    let includedHours: number[] = [];

    let reservationIntervalInMinutes = object.interval;

    let startDateTime = new Date(selectedDate);
    let startTimestamp = startDateTime.setHours(selectedDateWorktime.startHour, selectedDateWorktime.startMinute, 0, 0);   
    
    if(startTime && startTime.day() === startDateTime.getDay()) {
        startTimestamp = startDateTime.setHours(startTime.hour(), startTime.minute(), 0, 0);   
    }

    let endDateTime = new Date(selectedDate);
    let endTimestamp = endDateTime.setHours(selectedDateWorktime.endHour, selectedDateWorktime.endMinute, 0, 0);

    if(offsetStart) {
        startTimestamp += offsetStart * 60 * 1000;        
    }

    if(offsetEnd) {
        endTimestamp -= offsetEnd * 60 * 1000;
    }

    if(disableMinutesFromEnd) {
        endTimestamp -= (disableMinutesFromEnd * 60 * 1000);
    }

    for (let timestamp = startTimestamp; timestamp <= endTimestamp; timestamp += (reservationIntervalInMinutes * 60 * 1000)) {
        if (timestamp >= currentTime.getTime() && timestamp <= endTimestamp) {
            let tsDateTime = new Date(timestamp);
            if (!includedHours.includes(tsDateTime.getHours())) {
                includedHours.push(tsDateTime.getHours());
            }
        }
    }

    let allHours: number[] = range(0, 24);
    let theDisabledHours = allHours.filter(hour => !includedHours.includes(hour));
    return theDisabledHours;
}

export function disabledMinutesForSelectedDateAndHour(date: Date | undefined, hour: number, object: IObject, disabledMinutesFromEnd?: number, offsetStart?: number, offsetEnd?: number, startTime?: Dayjs): number[] {
    let now: Date = new Date();

    let selectedDate = date;
    if (!selectedDate) {
        return range(0, 60);
    }

    let worktime = object.worktime.find(wt => wt.dayOfWeek === selectedDate?.getDay());
    if (!worktime) {
        return range(0, 60);
    }

    let interval = object.interval;    

    let startDateTime = new Date(selectedDate);
    let start = startDateTime.setHours(worktime.startHour, worktime.startMinute, 0, 0);   
    if(startTime && startTime.day() === startDateTime.getDay()) {
        
        start = startDateTime.setHours(startTime.hour(), startTime.minute(), 0, 0);   
    } 

    let endDateTime = new Date(selectedDate);
    let end = endDateTime.setHours(worktime.endHour, worktime.endMinute, 0, 0);

    let includedMinutes: number[] = [];
    if(offsetStart) {
        start += offsetStart * 60 * 1000;
    }
    if(offsetEnd) {
        end -= offsetEnd * 60 * 1000;
    }
   
    if(disabledMinutesFromEnd) {
        end -= disabledMinutesFromEnd * 60 * 1000;
    }

    // loop through the work time
    for (let currentTime = start; currentTime <= end; currentTime += (interval * 60 * 1000)) {
        let currDateTime = new Date(currentTime);

        if (now > currDateTime || currDateTime > endDateTime) {
            continue;
        }

        if(startTime && dayjs(currDateTime).isBefore(startTime)) {          
            continue;
        }

        if (currDateTime.getHours() === hour) {

            if (!includedMinutes.includes(currDateTime.getMinutes())) {
                includedMinutes.push(currDateTime.getMinutes());
            }
        }
    }

    let excludedMinutes: number[] = range(0, 60);
    return excludedMinutes.filter(minute => !includedMinutes.includes(minute));
}